import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { format } from "date-fns";
//import { FiPhoneCall } from "react-icons/fi";

interface IProps {
    singleData: any,
    open: boolean,
    toast: any,
    loadTableData: () => void,
    HidePenFollowup: () => void,
}

const schema = yup.object({
});
interface ISubNum {
}
let EmptyRequirement: ISubNum = {
};

export const Dailer = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [loading, setLoading] = useState(false);
    const [dialedNumber, setDialedNumber] = useState("");
    const [isCalling, setIsCalling] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRequirement,
        shouldFocusError: false
    });

    const onHide = () => {
        props.HidePenFollowup();
    }

    const dt = useRef<any>(null);

    return (
        <>
            <Dialog header="" visible={props.open} style={{ width: '300px' }} onHide={props.HidePenFollowup}>
                <div className="flex flex-column align-items-center justify-content-center gap-4 p-4">
                    <div className="text-green-600 text-xl font-semibold">Calling...</div>

                    <div className="text-2xl font-bold text-gray-800">
                        {dialedNumber}
                    </div>

                    {/* <FiPhoneCall size={60} className="text-green-500 animate-bounce" /> */}

                    <Button
                        label="End Call"
                        icon="pi pi-times"
                        className="p-button-rounded p-button-danger mt-3"
                        onClick={() => {
                            setIsCalling(false);
                            onHide()
                        }}
                    />
                </div>
                {/* <div className="flex flex-column align-items-center justify-content-center gap-3 p-3">
                    <div className="w-full text-center text-xl font-semibold border-1 border-round p-2" style={{ borderColor: '#ccc', minHeight: '40px' }}>
                        {dialedNumber || "Enter Number"}
                    </div>
                    <div className="grid grid-cols-3 mt-3 gap-2 w-full">
                        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'].map((num) => (
                            <Button key={num} label={num} className="w-full p-button-rounded"
                                style={{ padding: '1rem', fontSize: '1.25rem', fontWeight: 'bold' }} onClick={() => setDialedNumber(prev => prev + num)} />
                        ))}
                    </div>
                    <div className="flex justify-content-center gap-4 mt-3">
                        <Button icon="pi pi-phone" className="p-button-rounded p-button-success" style={{ width: '50px', height: '50px' }} onClick={() => setIsCalling(true)} disabled={isCalling || !dialedNumber} />
                        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" style={{ width: '50px', height: '50px' }} onClick={() => { setIsCalling(false); setDialedNumber(''); }} />
                    </div>
                    {isCalling && (
                        <div className="mt-2 text-green-600 font-medium">
                            Calling {dialedNumber}...
                        </div>
                    )}
                </div> */}
            </Dialog>
        </>
    );
};